// Values match the API's camelCase JsonStringEnumConverter output (ARES.Domain.Enums.OverDueAgingBucket).
export enum OverdueAgingBucket {
    Normal = 'normal',
    Overdue = 'overdue',
    Critical = 'critical',
}
